<script>
import Vue from 'vue'

export default new Vue({
    data() {
        return {
        }
    },
})
</script>
